// --------------- TYPES ---------------
import { GetUserProfile, IsSignedIn } from '../Types'
import { ADMIN_AUTH_STATUS, requiresAdminEnrollment } from '../../common/adminAuth'

// --------------- INITIAL STATE ---------------
const INITIAL_STATE = {
  error: null,
  signedIn: false,
  authStatus: ADMIN_AUTH_STATUS.IDLE,
  data: null,
  isUserProfileSuccess: null,
  needsEnrollment: false,
}

// --------------- REDUCER FUNCTION ---------------
const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetUserProfile.REQUEST:
      return {
        ...state,
        isUserProfileSuccess: null,
        error: null,
        authStatus: ADMIN_AUTH_STATUS.CHECKING,
      }
    case GetUserProfile.SUCCESS: {
      const needsEnrollment = requiresAdminEnrollment(action.payload)
      return {
        ...state,
        isUserProfileSuccess: true,
        error: null,
        signedIn: true,
        authStatus: needsEnrollment
          ? ADMIN_AUTH_STATUS.ENROLLMENT_REQUIRED
          : ADMIN_AUTH_STATUS.AUTHENTICATED,
        data: action.payload,
        needsEnrollment,
      }
    }
    case GetUserProfile.FAILED:
      return {
        ...state,
        isUserProfileSuccess: false,
        signedIn: false,
        authStatus: ADMIN_AUTH_STATUS.ANONYMOUS,
        data: null,
        error: action.payload,
        needsEnrollment: false,
      }
    case IsSignedIn.SET_IS_SIGNED_IN:
      return {
        ...state,
        signedIn: action.payload,
        authStatus: action.payload ? ADMIN_AUTH_STATUS.AUTHENTICATED : ADMIN_AUTH_STATUS.ANONYMOUS,
        data: action.payload ? state.data : null,
        error: null,
        isUserProfileSuccess: action.payload ? state.isUserProfileSuccess : false,
        needsEnrollment: action.payload ? state.needsEnrollment : false,
      }
    default:
      return state
  }
}

export default authReducer
